/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { ControlType, ISettingGroupDefinition } from "@nuance/hierarchical-settings-ui-domain";
import { DomainDataMapperOptionsBase } from "./DomainDataMapperOptionsBase";

export class DomainDataMapperDropdown extends DomainDataMapperOptionsBase {
    constructor(settingDefinition: ISettingGroupDefinition) {
        super(settingDefinition);
    }

    RequiredControlTypeFunc(): ControlType.RadioField | ControlType.DropdownField {
        return ControlType.DropdownField;
    }
}
